// extracted by mini-css-extract-plugin
module.exports = {"fullWidthCard":"full-width-card_fullWidthCard___tT_1"};